<div fxLayout="row" fxLayoutAlign="space-between center">
  <h2>Credential Configurations</h2>
  <button
    mat-icon-button
    [routerLink]="['create']"
    matTooltip="Create New Credential Configuration"
  >
    <mat-icon>add</mat-icon>
  </button>
</div>

<table mat-table [dataSource]="configs" class="mat-elevation-z8">
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef>ID</th>
    <td mat-cell *matCellDef="let config">{{ config.id }}</td>
  </ng-container>

  <ng-container matColumnDef="description">
    <th mat-header-cell *matHeaderCellDef>Description</th>
    <td mat-cell *matCellDef="let config">{{ getDescription(config) }}</td>
  </ng-container>

  <ng-container matColumnDef="keyBinding">
    <th mat-header-cell *matHeaderCellDef>Key Binding</th>
    <td mat-cell *matCellDef="let config">{{ config.keyBinding }}</td>
  </ng-container>

  <ng-container matColumnDef="lifeTime">
    <th mat-header-cell *matHeaderCellDef>Lifetime</th>
    <td mat-cell *matCellDef="let config">{{ config.lifeTime }}</td>
  </ng-container>

  <ng-container matColumnDef="statusManagement">
    <th mat-header-cell *matHeaderCellDef>Status Management</th>
    <td mat-cell *matCellDef="let config">{{ config.statusManagement }}</td>
  </ng-container>

  <ng-container matColumnDef="embeddedDisclosurePolicy">
    <th mat-header-cell *matHeaderCellDef>Embedded Disclosure Policy</th>
    <td mat-cell *matCellDef="let config">{{ config.embeddedDisclosurePolicy?.policy }}</td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>Actions</th>
    <td mat-cell *matCellDef="let config">
      <button mat-icon-button [routerLink]="[config.id]">
        <mat-icon>visibility</mat-icon>
      </button>
      <button mat-icon-button [routerLink]="[config.id, 'edit']">
        <mat-icon>edit</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
